import {SearchFormPresenter} from "@modules/onBoarding/application/port/output/SearchFormPresenter";
import {LoadSearchFormPort} from "@modules/onBoarding/application/port/input/LoadSearchFormPort";

export class LoadSearchForm<OUTPUT> implements LoadSearchFormPort<OUTPUT> {

    constructor(private readonly presenter: SearchFormPresenter<OUTPUT>) {
    }

    async execute(): Promise<OUTPUT> {
        return this.presenter.displayForm();
    }
}
